module.exports = __webpack_public_path__ + "img/placeholder.6293a861.jpeg";